import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class FocusTrackerService {
    lastControl?: string;
    lastTag?: string;
    isComposing = false;

    constructor() {
        window.addEventListener('focusIn', (event) => {
            const target = event.target as HTMLElement | null;

            if (!target) return;

            this.lastTag = target.tagName?.toLowerCase();
            this.lastControl = target.getAttribute('formControlName')
                                || target.getAttribute('id')
                                || target.getAttribute('name')
                                || undefined;
        }, true);

        document.addEventListener('compositionStart', () => {
            this.isComposing = true;
        }, true);

        document.addEventListener('compositionEnd', () => {
            this.isComposing = false;
        }, true);
    }
}